import { Slot } from '@radix-ui/react-slot';
import type { ReactElement } from 'react';
import { forwardRef } from 'react';
import { twMerge } from 'cn';
import { Combo } from './combo.jsx';
import type { ContainerProps } from './types.js';

/** `<Container>` component. */
export const Container = forwardRef<HTMLDivElement, ContainerProps>(
  ({ asChild, children, className, combo, ...props }, forwardedRef): ReactElement => {
    const Component = asChild ? Slot : 'div';

    return (
      <Component
        className={twMerge('rounded-8 bg-base-100 p-6', className)}
        ref={forwardedRef}
        {...props}
      >
        {combo ? <Combo combo={combo} /> : children}
      </Component>
    );
  }
);
